module.exports = __webpack_public_path__ + "static/img/4443_phase_function_Paper_Points.88d6229.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4443_phase_function_Paper_Points.png
// module id = omLG
// module chunks = 0